// @flow
import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'seedling/constants';
import { clearFix } from 'polished';

type TagProp = React.ComponentType<any> | Class<any> | string;

type Props = {
  header?: TagProp,
  body?: TagProp,
  svg?: TagProp,
  backgroundColor?: string,
  lineHeight?: string,
  alignItems?: string,
  padding?: string,
};

const renderTag = (Tag: ?TagProp) => {
  if (!Tag) return null;

  if (Tag.prototype && Tag.prototype.isReactComponent) {
    return <Tag />;
  } else if (typeof Tag === 'function') {
    return Tag();
  } else {
    return Tag;
  }
};

const Nudge = (props: Props) => {
  const {
    alignItems,
    backgroundColor = colors.white,
    body,
    header,
    lineHeight,
    padding,
    svg,
  } = props;

  return (
    <NudgeContainer
      alignItems={alignItems}
      backgroundColor={backgroundColor}
      lineHeight={lineHeight}
      padding={padding}
    >
      {renderTag(svg)}
      <NudgeText>
        {renderTag(header)}
        {renderTag(body)}
      </NudgeText>
    </NudgeContainer>
  );
};

Nudge.displayName = 'Nudge';

const NudgeContainer = styled.div`
  border-radius: 3px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.backgroundColor};
  border: 1px solid ${colors.lightGrey};
  padding: ${props => props.padding || '10px 20px'};
  position: relative;
  box-sizing: border-box;
  line-height: ${props => props.lineHeight || '35px'};
  display: flex;
  align-items: ${props => props.alignItems || 'center'};
  ${clearFix()}
`;

NudgeContainer.displayName = 'NudgeContainer';

const NudgeText = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1em;
`;

NudgeText.displayName = 'NudgeText';

export default Nudge;
